module.exports = __webpack_public_path__ + "static/img/2.9f5d4ad1.png";